export const useSnackbar = () => {
  //
  // Configuration
  //
  const config = useRuntimeConfig();

  //
  // State
  //
  const snackbar = useState<boolean>("snackbar", () => false);
  const snackbarText = useState<string>("snackbarText", () => "");
  const snackbarColor = useState<string>("snackbarColor", () => "grey");
  const snackbarTimeout = useState<number>("snackbarTimeout", () => config.public.ui.snackbarTimeout);
  const snackbarIcon = useState<string | undefined>("snackbarIcon", () => undefined);
  const snackbarActionText = useState<string | undefined>("snackbarActionText", () => undefined);
  const snackbarActionHandler = useState<(() => void) | undefined>("snackbarActionHandler", () => undefined);

  // Reopen token — used to replay the entrance animation when showing a new
  // message while the snackbar is already visible.
  let reopenToken: ReturnType<typeof setTimeout> | null = null;

  //
  // Methods
  //
  const showSnackbar = (
    text: string,
    options?: {
      color?: string;
      timeout?: number;
      icon?: string;
      actionText?: string;
      onAction?: () => void;
    },
  ) => {
    if (reopenToken !== null) {
      clearTimeout(reopenToken);
      reopenToken = null;
    }

    const apply = () => {
      snackbarText.value = text;
      snackbarColor.value = options?.color ?? "grey";
      snackbarTimeout.value = options?.timeout ?? config.public.ui.snackbarTimeout;
      snackbarIcon.value = options?.icon;
      snackbarActionText.value = options?.actionText;
      snackbarActionHandler.value = options?.onAction;
      snackbar.value = true;
    };

    if (snackbar.value) {
      snackbar.value = false;
      reopenToken = setTimeout(() => {
        reopenToken = null;
        apply();
      }, 150);
    } else {
      apply();
    }
  };

  const hideSnackbar = () => {
    snackbar.value = false;
  };

  return {
    // State
    snackbar,
    snackbarText,
    snackbarColor,
    snackbarTimeout,
    snackbarIcon,
    snackbarActionText,
    snackbarActionHandler,

    // Methods
    showSnackbar,
    hideSnackbar,
  };
};
